import { useGetEquipment } from '_api';
import { ConstantsNameDescriptions } from '_api/types';
import { useMemo } from 'react';

const useEquipment = () => {
  const { data: getEquipment, isFetching: isFetchingEquipment } = useGetEquipment({});

  const equipmentOptions = useMemo<ConstantsNameDescriptions<number>[]>(
    () =>
      getEquipment
        ? getEquipment.map((equip) => ({
            name: equip.id,
            description: equip.title,
          }))
        : [],
    [getEquipment],
  );
  return { equipmentOptions, isFetchingEquipment };
};

export default useEquipment;
